// src/components/LandingMarketFilterPills.js
import React from 'react';
import styles from './LandingMarketFilterPills.module.css';

export const LANDING_MARKET_MODES = {
  LARGEST: 'largest',
  WINNERS: 'winners',
  LOSERS: 'losers',
};

export default function LandingMarketFilterPills({ value, onChange }) {
  const pillClass = (isActive) => (isActive ? `${styles.pill} ${styles.active}` : styles.pill);

  return (
    <div className={styles.filter} aria-label="Market table filter">
      <button
        type="button"
        className={pillClass(value === LANDING_MARKET_MODES.LARGEST)}
        onClick={() => onChange(LANDING_MARKET_MODES.LARGEST)}
      >
        Largest Companies
      </button>

      <button
        type="button"
        className={pillClass(value === LANDING_MARKET_MODES.WINNERS)}
        onClick={() => onChange(LANDING_MARKET_MODES.WINNERS)}
      >
        Biggest Winners
      </button>

      <button
        type="button"
        className={pillClass(value === LANDING_MARKET_MODES.LOSERS)}
        onClick={() => onChange(LANDING_MARKET_MODES.LOSERS)}
      >
        Biggest Losers
      </button>
    </div>
  );
}
